import { Component, Input, OnInit, Output, EventEmitter, HostListener, ElementRef, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { of, Subject, takeUntil, map } from 'rxjs';
import { LocalizationService } from '../../services/localization.service';
import { AppliedFilter, FilterConfig, OperatorEnum } from 'src/app/core/interfaces/filter.interface';

@Component({
  selector: 'app-filter-v2',
  templateUrl: './filter-v2.component.html',
  styleUrl: './filter-v2.component.scss'
})
export class FilterV2Component implements OnInit, OnDestroy, OnChanges {
  @Input({ required: true }) filterConfigs: FilterConfig[];
  @Input() initialAppliedFilters: AppliedFilter[] = [];

  @Output() appliedFilters = new EventEmitter<AppliedFilter[]>();

  appliedFiltersList: AppliedFilter[] = [];

  isOpen = false;

  labelKey: "label" | "labelAr" = 'label';
  currentLang = "ar";

  currentOption: FilterConfig | null = null;

  private destroy$ = new Subject<void>();

  formGroup?: FormGroup;

  currentSelectedOption?: String;

  submit() {
    const formValue = this.formGroup?.value as { key: string, value: string, value1: string, operator: string };
    const newFilter = {
      key: formValue.key,
      value: formValue.value,
      label: this.currentOption?.label ?? '',
      labelAr: this.currentOption?.labelAr ?? '',
      operator: OperatorEnum.find((el) => el.key === formValue.operator)!,
      valueDes: this.currentSelectedOption ?? formValue.value,
    };

    this.appliedFiltersList.push(newFilter);
    this.appliedFilters.emit(this.appliedFiltersList);
    this.reset();
  }

  private reset() {
    this.isOpen = false;
    this.formGroup?.reset();
    this.currentOption = null;
  }

  removeFilter(filter: AppliedFilter) {
    this.appliedFiltersList = this.appliedFiltersList.filter(f => f !== filter);
    this.appliedFilters.emit(this.appliedFiltersList);
    this.reset();
  }

  removeAll() {
    this.appliedFiltersList = [];
    this.appliedFilters.emit(this.appliedFiltersList);
    this.reset();
  }


  ngOnChanges(changes: SimpleChanges): void {
    // تحديث الفلاتر المطبقة عند تغيير initialAppliedFilters
    if (changes['initialAppliedFilters'] && this.initialAppliedFilters) {
      this.appliedFiltersList = [...this.initialAppliedFilters];
    }
  }

  ngOnInit(): void {
    this.localzationService.currentLanguage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => {
        this.labelKey = lang === 'en' ? 'label' : 'labelAr';
        this.currentLang = lang;
      });

    // تهيئة الفلاتر المطبقة مسبقاً (من localStorage)
    if (this.initialAppliedFilters && this.initialAppliedFilters.length > 0) {
      this.appliedFiltersList = [...this.initialAppliedFilters];
    }

    this.initForm();
  }

  initForm() {
    this.formGroup = this.fb.group({
      key: [null, [Validators.required]],
      value: [null, [Validators.required]],
      value1: [null],
      operator: [null]
    })
  }

  getControl(name: string) {
    return this.formGroup!.get(name) as FormControl;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSelectColumn(vlaue: FilterConfig) {
    this.currentOption = vlaue;
  }

  getFiltersConfig = () => {
    return of(this.filterConfigs);
  }

  getCurrentFilterOptions = (page: number, size: number, search: string) => {
    if (this.currentOption?.options) {
      const options = this.currentOption?.options ?? [];
      // حذف خيار "الكل" من القائمة
      const filteredOptions = options.filter(opt => {
        const key = String(opt.key).toLowerCase();
        const label = String(opt.label || '').toLowerCase();
        const labelAr = String(opt.labelAr || '').toLowerCase();
        return key !== 'all' && label !== 'all' && labelAr !== 'الكل';
      });
      return of(filteredOptions);
    } else if (this.currentOption?.optionsFnc) {
      return this.currentOption?.optionsFnc(page, size, search).pipe(
        map(options => {
          // حذف خيار "الكل" من القائمة
          return options.filter(opt => {
            const key = String(opt.key).toLowerCase();
            const label = String(opt.label || '').toLowerCase();
            const labelAr = String(opt.labelAr || '').toLowerCase();
            return key !== 'all' && label !== 'all' && labelAr !== 'الكل';
          });
        })
      );
    }

    return of([]);
  }

  getCurrentFilterOption = (id: string) => {
    return of(null);
  }

  getOperators = () => {
    // إرجاع فقط "يساوي" و "لا يساوي"
    const allowedOperators = OperatorEnum.filter(op => op.key === 'EQ' || op.key === 'NEQ');
    return of(allowedOperators);
  }

  @HostListener('document:click', ['$event'])
  clickOut(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const isInsideComponent = this.eRef.nativeElement.contains(target);

    const isInsideChildOverlay = !!target.closest('ng-dropdown-panel');

    if (!isInsideComponent && !isInsideChildOverlay && this.isOpen) {
      this.isOpen = false;
    }
  }

  constructor(private eRef: ElementRef,
    private localzationService: LocalizationService,
    private fb: FormBuilder
  ) { }
}
